var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{on:{"click":function($event){return _vm.abrirFintoc()}}},[_vm._v("Conectar Cuenta con Fintoc")])
}
var staticRenderFns = []

export { render, staticRenderFns }